/**
 * True only for Cmd/Ctrl+Shift+P — the Anvil command-palette shortcut.
 *
 * Deliberately NOT Cmd/Ctrl+K (reserved by the existing global search / omnibar
 * in GlobalHotKeys) and NOT Cmd/Ctrl+P (reserved elsewhere), so the palette
 * cannot clobber existing shortcuts.
 */
export function isCommandPaletteShortcut(event: KeyboardEvent): boolean {
  const key = (event.key || "").toLowerCase();

  return Boolean(
    (event.metaKey || event.ctrlKey) && event.shiftKey && key === "p",
  );
}
